// color theme

const colorTheme = {
    background: '#FFFFFF',
    bars: '#353535',
    boldTheme: '#284B63',
    mediumTheme: '#94A5B1',
    lightTheme: '#F2F4F6',
    accent: '#CB143D'
}

export {colorTheme}